

import {  useEffect, useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import apiService from "../api/ApiService";
import { addComments } from "../redux/slices/commentsSlice";
import { toast } from "react-toastify";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import { addCattleListComment, addPenListComment, changeCommentMode, changePenMode } from "../redux/slices/listDamSlice";
import { Category, Close, Group, Title } from "@mui/icons-material";
import { useForm } from "react-hook-form";

const moment=require('moment-jalaali');


const AddComment=({flag})=>{
    const {currentAdmin}=useSelector(state=>state.p.admin)
    const {currentCattle}=useSelector(state=>state.cattle);
    const {currentSingleSensor}=useSelector(state=>state.singleSensor);
    const {cattleListAddComment,cattleId,commentMode,penListComment,penCommentMode}=useSelector(state=>state.list)
    const {currentComments}=useSelector(state=>state.comments)
    const {currentPens,tempPen}=useSelector(state=>state.pens)

    const [types,setTypes]=useState([])
   
    const {
        register,
        handleSubmit,
        formState: { errors }
      } = useForm();

    const {isModalCommentOpen,closeModallComment,openModallComment}=useGlobalContext();
   
    const dispatch=useDispatch();
    const navigate=useNavigate()
    const getTypes=async()=>{
        
            const res=await apiService.getCattleComment()
            setTypes(res.data)
        
    }
    const getTypesSens=async()=>{
        const res=await apiService.getSensorComment();
        setTypes(res.data)
    
}
const getTypesPens=async()=>{
    const res=await apiService.getPensCommentsTypes();
    setTypes(res.data)

}
const getTypesFarm=async()=>{
    const res=await apiService.getCommentFarmTypes();
    setTypes(res.data)

}
    const AddNewSensor=async(dataa)=>{
        const {comment,type,title}=dataa
       const filterCattleId=cattleListAddComment.map(item=>{return item.id})
            const filt=cattleListAddComment.map(item=>{
                if(item?.id){
                    return item.id
                }else{
                    return item
                }
            })
            const data=JSON.stringify({
                "cattleIds": 
                    filt?.length?filt:[currentCattle.id]
                  ,
                "title": title,
                "comment": comment,
                "cattleCommentTypeId": type
              })
            const res=await apiService.addNewComment(data);
            {flag=='cattle'&&dispatch(addComments([...currentComments,...res.data]))}
            {flag=='cattles'&&cattleId?(filterCattleId.includes(cattleId)&&dispatch(addComments([...currentComments,...res.data]))):dispatch(addComments([...currentComments,...res.data]))}

            dispatch(addCattleListComment([]))
            openModallComment()
       
      
       
    }
    const AddNewSensorComm=async(dataa)=>{
        const {comment,type,title}=dataa
            const data=JSON.stringify({
                "title": title,
                "comment": comment,
                "sensorCommentTypeId": type
              })
            const res=await apiService.addNewSensorComment(currentSingleSensor.id,data);
            dispatch(addComments([...currentComments,res.data]))
            openModallComment()
       
    }
    const AddNewPenComment=async(dataa)=>{
        const {comment,type,title}=dataa
        console.log(tempPen,penListComment)
            const data=JSON.stringify({
                "penIds": 
                    penListComment.length>0?penListComment:([tempPen])
                  ,
                "title": title,
                "comment": comment,
                "penCommentTypeId": type
              })
            const res=await apiService.addPensComments(data);
            dispatch(changePenMode(penCommentMode))
            dispatch(addComments([...res.data,currentComments]))
            openModallComment()
    }
    const AddNewFarmComment=async(dataa)=>{
        const {comment,type,title}=dataa
            const data=JSON.stringify({
                "farmIds": [
                  currentAdmin.id
                ],
                "title": title,
                "comment": comment,
                "farmCommentTypeId":type
              })
            const res=await apiService.addFarmComment(data);
            dispatch(addComments([...res.data,...currentComments]))
            dispatch(addCattleListComment([]))
            openModallComment()
    }
  useEffect(()=>{
    flag=='sensor'&&getTypesSens()
    flag=='cattle'&&getTypes()
    flag=='cattles'&&getTypes()
flag=='pens'&&getTypesPens()
flag=='farm'&&getTypesFarm()  },[])
    

    return <div onClick={closeModallComment} className={`modal-overlay ${isModalCommentOpen&&'show-modal'} `}>
        <form onSubmit={handleSubmit((flag==='cattle'||flag==='cattles')?AddNewSensor:(flag==='sensor'?AddNewSensorComm:(flag=='pens'?AddNewPenComment:AddNewFarmComment)))} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
                <AddToPhotosIcon fontSize="large"/>
            <h4 > ایجاد کامنت جدید</h4>
            </div>
       
            <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a"  {...register("title",{
              required: 'این مقدار ضروری است',pattern:{
                value:/.{1,100}/,
                message:'فقط 100 کاراکتر'
              }
            })}/>
            <label for="" className={'labelSS'}><Title fontSize="small"/> موضوع </label>
            {errors?.title?.message&&<span className='errMsg'>{errors?.title?.message}</span>}
        </div>
        <div className="SelConn">
        <label for='sele' ><Category fontSize="small"/> دسته:</label>
        <select  id='sele'  name='sele' className="selectInp"  {...register("type",{
              required: 'این مقدار ضروری است'
            })}>
                            <option  value={''}>   انتخاب کنید</option>

            {types?.map((item,index)=>{
                return <option key={index} value={item.id}>{item.title}</option>
            })}
        </select>
        {errors?.type?.message&&<span className='errMsg'>{errors?.type?.message}</span>}
        </div>
        <div className='inputContainerSS2'>
            <textarea autoComplete="off" type="text"   className='inputSS inputSSText2' placeholder="a"  {...register("comment",{
              required: 'این مقدار ضروری است',pattern:{
                value:/.{1,1000}/,
                message:'فقط 1000 کاراکتر'
              }
            })}/>
            <label for="" className={'labelSS labelText'}>متن</label>
            {errors?.comment?.message&&<span className='errMsg'>{errors?.comment?.message}</span>}
        </div>
        
        <button className="EditMOdalBtnForm" type="submit">
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
    </div>
}
export default  AddComment